import React from "react";
import Layout from "../components/layout";
import "../styles/scan.css";
import { Link } from "react-router-dom";

import entry from "../assets/check.png";
import exit from "../assets/exit.png";

const QrScan = () => {
  return (
    <Layout>
      <div className="App px-5 mt-3">
        <div className="d-flex justify-content-center">
          <h3 className="page-title">Scan des Cartes Adhérants</h3>
        </div>
        <div className="d-flex justify-content-center mt-10 card-container">
          <Link to={`/scan-entry`} className="card-link">
            <div className="card-button entry-card">
              <img src={entry} alt="" className="card-image entry-image" />
              <p className="card-title">Scanner d'entrée</p>
            </div>
          </Link>
          <Link to={`/scan-exit`} className="card-link">
            <div className="card-button exit-card">
              <img src={exit} alt="" className="card-image exit-image" />
              <p className="card-title">Scanner de sortie</p>
            </div>
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default QrScan;
